<template>
  <div>
    <!-- Certificates -->
    <div class="certificates-container">
      <div
        v-for="certificate in computedCertificates"
        :key="certificate.id"
      >
        <div>
          <div class="flexBox card-container">
            <div class="card-col">
              <div class="fontSmaller paddingBottom">
                <label>State:</label>
                <span>{{ certificate.exposureZone.name }}</span>
              </div>
              <div
                v-if="certificate.exemptionNumber"
                class="fontSmaller paddingBottom"
              >
                <label>Exemption Number:</label>
                <span>{{ certificate.exemptionNumber }}</span>
              </div>
              <div
                v-if="certificate.signedDate"
                class="fontSmaller paddingBottom"
              >
                <label>Signed Date:</label>
                <span>{{ certificate.signedDate }}</span>
              </div>
              <div
                v-if="certificate.expirationDate"
                class="fontSmaller paddingBottom"
              >
                <label>Expiration Date:</label>
                <span>{{ certificate.expirationDate }}</span>
              </div>
              <div class="fontSmaller paddingBottom">
                <label>Status:</label>
                <span>{{ certificate.status }}</span>
              </div>
            </div>
            <div class="card-col flexBoxCentered">
              <div
                v-if="isLoadingView.indexOf(certificate.id) >= 0"
                class="loadingContainer"
              >
                <div class="loading" />
              </div>
              <img
                v-else-if="certificate.previewSrc"
                :src="certificate.previewSrc"
                alt="Certificate Preview"
                class="cursorZoomIn"
                @click="enlargePreview(certificate.previewSrc)"
              >
              <img
                v-else
                src="../../assets/certificate-preview-placeholder.png"
                alt="Certificate Preview"
                class="cursorPointer"
                @click="download(certificate.id)"
              >
            </div>
          </div>

          <div class="card-action">
            <div>
              <div v-if="isDeleting.indexOf(certificate.id) >= 0">
                <button class="cancelButton borderlessButton">
                  <div class="loading" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import apiMixin from '@/mixins/apiMixin.js'
import moment from 'moment'
/**
 * The CertCapture certificate list Component for CertCapture page.
 * @displayName CertCapture Certificate List
 */
export default {
  name: 'CertificateListComponent',
  components: {},
  mixins: [apiMixin],
  props: ['certificates', 'deleteCertificate'],
  data () {
    return {
      certificatePreviewSrc: null,
      isLoadingView: [],
      isDeleting: [],
      showConfirmDelete: false,
      displayCertificates: []
    }
  },

  computed: {
    computedCertificates: function () {
      return this.displayCertificates.slice(0).map(cert => {
        const signedMoment = moment(cert.signedDate)
        if (signedMoment) {
          cert.signedDate = signedMoment.format('MM-DD-YYYY')
        }
        const expirationMoment = moment(cert.expirationDate)
        if (expirationMoment) {
          cert.expirationDate = expirationMoment.format('MM-DD-YYYY')
        }
        cert.status = cert.status.toLowerCase()
        cert.status = cert.status.charAt(0).toUpperCase() + cert.status.slice(1)
        return cert
      })
    }
  },
  watch: {
    /**
     * Gets called when certificate list in store changes, will update displayCertificates.
     *
     * @public
     */
    certificates: function () {
      this.displayCertificates = this.certificates
    }
  },
  mounted () {
    this.displayCertificates = this.certificates
  },

  methods: {
    /**
     * Gets called when user clicks to preview certificate.
     *
     * @public
     */
    download: function (id) {
      this.isLoadingView.push(id)
      this.$store
        .dispatch('downloadExemptionCertificate', { certificate_id: id })
        .then(response => {
          this.isLoadingView = this.isLoadingView.filter(value => {
            return value !== id
          })
          if (response.data) {
            this.displayCertificates = this.displayCertificates.map(certificate => {
              if (certificate.id === id) {
                certificate.previewSrc = `data:image/jpeg;base64,${response.data}`
              }
              return certificate
            })
          }
        })
    },
    /**
     * Gets called when user clicks certificate preview. Will open certificate preview in new tab.
     *
     * @public
     */
    enlargePreview: function (src) {
      // Open this data url in new tab
      const image = new Image()
      image.src = src
      const w = window.open('')
      w.document.write(image.outerHTML)
    }
  }
}
</script>

<style scoped>
.certificates-container ul li {
  list-style: none;
  display: flex;
}
.certificates-container ul li > div:nth-child(1) {
  padding: 2rem;
}
.certificates-container ul li > div:nth-child(2) {
  display: flex;
  justify-content: space-between;
  flex-grow: 1;
}
.card-container {
  width: 28rem;
}
.status {
  font-size: 1rem;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  border-radius: 0.3rem;
  background: #cacaca;
  border-color: #cbcbcbcb;
  color: #2a2a2a;
}
.card-col {
  flex-basis: 50%;
}
.card-col img {
  height: 100%;
  max-width: 14rem;
}
.loadingContainer {
  height: 100%;
  width: 100%;
  max-width: 14rem;
}
.loading {
  margin: 0 auto;
}
.cancelButton {
  height: 3rem;
  line-height: 3rem;
}
.paddingBottom {
  padding-bottom: 0.5rem;
}
</style>
